// extracted by mini-css-extract-plugin
export default {"page":"requestPasswordResetPage_page__DC+yY"};